export enum QUERY_KEYS {
  createCompanyUser = 'create-company-user',
  createCompanyWidget = 'create-company-widget',
  deleteCompanyUser = 'delete-company-user',
  getCompany = 'company',
  getCompanyBookingStats = 'company-booking-stats',
  getCompanyChannels = 'company-channels-by-id',
  getCompanyClubs = 'company-clubs',
  getCompanyCurrencies = 'company-currencies',
  getCompanyEventStats = 'company-event-stats',
  getCompanyInfo = 'company-info',
  getCompanyIntegrations = 'company-ar-token',
  getCompanyPermissions = 'company-permissions',
  getCompanyRolePermissions = 'company-roles',
  getCompanyRoles = 'company-roles',
  getCompanyStats = 'company-stats',
  getCompanyUserInfo = 'company-user-info',
  getCompanyUserList = 'get-company-user-list',
  getCompanyVatRates = 'company-vat-rates',
  getCompanyWidget = 'company-widget-settings',
  getCountries = 'get-company-countries',
  requestNewVenue = 'request-new-venue',
  updateCompanyInfo = 'update-company-info',
  updateCompanyIntegrations = 'update-company-ar-token',
  updateCompanyLogo = 'update-company-logo',
  updateCompanyVatRates = 'update-company-vat-rates',
  updateCompanyWidget = 'update-company-widget',
  updateUserRole = 'update-user-role',
}
